import {extendVariants, Button as HeroUIButton} from "@heroui/react";

const Button = extendVariants(HeroUIButton, {
    defaultVariants: {
        radius: 'sm',
        color: 'default',
    },
    variants: {
        color: {
            white: 'shadow-xs bg text-foreground border border-default-300',
            default: 'text-default-600',
        },
        variant: {
            bordered: 'border',
            faded: 'border'
        },
        size: {
            xl: 'text-xl px-12 py-4 font-medium',
        },
        radius: {
            sm: 'rounded-md',
            md: 'rounded-xl',
            lg: 'rounded-2xl',
            xl: 'rounded-3xl',
        }
    },
})

export default Button